import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import SearchWatchdogModal from "./SearchWatchdogModal";

interface SearchWatchdogButtonProperties {
    searchQuery: string;
}

export const SearchWatchdogButton: React.FC<SearchWatchdogButtonProperties> = ({ searchQuery }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { t } = useTranslation();

    return (
        <div className='search-watchdog-container'>
            <div className="new-feature-tag">{t("searchWatchdog.newFeatureTag")}</div>
            <button
                onClick={() => setIsModalOpen(true)}
                className='search-watchdog-button'
            >
                <i className="fa-solid fa-dog"></i>&nbsp;
                {t("searchWatchdog.buttonText")}
            </button>
            <SearchWatchdogModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                searchQuery={searchQuery}
            />
        </div>
    );
};
